var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Card, compose, ExpandablePanel, graphql, Grid, GridColumn, Link, PageLayout, RightDiv, Separator, Spinner, Table, useQuery, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import serviceQuery from "../graphql/service.query.graphql";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import { lifecycle } from "recompose";
import TemplateDetailsQuery from "../graphql/template-details.query.graphql";
import StartWargameMutation from "../graphql/start-wargame.mutation.graphql";
import { TaskGroupView } from "../components/TaskGroupView";
import Button, { ButtonGroup } from "@atlaskit/button";
import VidPlayIcon from "@atlaskit/icon/glyph/vid-play";
import { parseDateTime } from "../utils/Utils";
import { PremiseDetailView } from "../components/PremiseDetailView";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import { WargameTemplatePublishStatus } from "../../__generated__/graphql-global-types";
import PublishWargameTemplateMutation from "../graphql/publish-template.mutation.graphql";
import { TemplateScheduleFormView } from "../components/FormView/TemplateScheduleForm";
import { WargameTemplateScheduleList } from "../components/ListView/WargameTemplateScheduleList";
import CopyIcon from "@atlaskit/icon/glyph/copy";
import { updatePremiseRequestMethod } from "../models/Premise";
import { warGameTemplateAllVersionsByIDQuery } from "../graphql";
import SectionMessage from "@atlaskit/section-message";
import Lozenge from "@atlaskit/lozenge";
import styled from "styled-components";
var TemplateDetailsComponent = function (props) {
    var _a, _b, _c, _d;
    var wargameTemplate = (_b = (_a = props === null || props === void 0 ? void 0 : props.templateDetailsData) === null || _a === void 0 ? void 0 : _a.warGameTemplate) !== null && _b !== void 0 ? _b : {};
    var search = window.location.search;
    var templateId = new URLSearchParams(search).get("id");
    var _e = __read(useState(false), 2), isMutationStarted = _e[0], setIsMutationStarted = _e[1];
    var _f = __read(useState(false), 2), isTemplatePublishing = _f[0], setIsTemplatePublishing = _f[1];
    var _g = __read(useState(false), 2), isExecutionModalOpen = _g[0], setIsExecutionModelOpen = _g[1];
    var _h = __read(useState(true), 2), isCollapsed = _h[0], setIsCollapsed = _h[1];
    var data = useQuery(warGameTemplateAllVersionsByIDQuery, {
        variables: {
            id: templateId
        }
    }).data;
    var templateAllVersions = data === null || data === void 0 ? void 0 : data.warGameTemplateAllVersionsByID;
    var templateAllVersionsSortedDesc = templateAllVersions === null || templateAllVersions === void 0 ? void 0 : templateAllVersions.sort(function (template1, template2) { return template2.id - template1.id; });
    var isVersionLatest = ((_c = templateAllVersionsSortedDesc === null || templateAllVersionsSortedDesc === void 0 ? void 0 : templateAllVersionsSortedDesc[0]) === null || _c === void 0 ? void 0 : _c.id) === parseInt(templateId);
    var publishWargameTemplate = function (event) {
        setIsTemplatePublishing(true);
        props
            .publishWargameMutation({
            variables: {
                id: wargameTemplate.id
            }
        })
            .then(function (result) {
            setIsTemplatePublishing(false);
            wargameTemplate.publishStatus = WargameTemplatePublishStatus.published;
        })
            .catch(function (reason) {
            console.log(reason);
            setIsTemplatePublishing(false);
        });
    };
    return props.templateDetailsData.loading || isMutationStarted ? (React.createElement(Spinner, null)) : (React.createElement(PageLayout, { title: "" },
        React.createElement("h2", null, "Wargame Plan Details"),
        !isVersionLatest && (React.createElement("div", null,
            React.createElement(SectionMessage, { appearance: "error" },
                "You are currently viewing an outdated version of the wargame plan. Check out the\u00A0",
                React.createElement("a", { href: "./template-details?id=" + ((_d = templateAllVersionsSortedDesc === null || templateAllVersionsSortedDesc === void 0 ? void 0 : templateAllVersionsSortedDesc[0]) === null || _d === void 0 ? void 0 : _d.id) }, "latest version.")),
            React.createElement("br", null))),
        React.createElement("div", null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 12 },
                    React.createElement(RightDiv, null,
                        React.createElement(ButtonGroup, null,
                            React.createElement(Link, { to: "./create-template?parent_id=" + wargameTemplate.id },
                                React.createElement(Button, { key: "duplicate", iconAfter: React.createElement(CopyIcon, { label: "copy", size: "small" }) }, "Duplicate")),
                            React.createElement("div", { hidden: true },
                                React.createElement(Button, { key: "delete", iconAfter: React.createElement(TrashIcon, { label: "delete", size: "small" }) }, "Delete")),
                            React.createElement("div", { hidden: !isVersionLatest },
                                React.createElement(Link, { to: "./template-edit?id=" + wargameTemplate.id },
                                    React.createElement(Button, { appearance: "primary", key: "Edit Template", iconAfter: React.createElement(EditFilledIcon, { label: "edit template", size: "small" }) }, "Edit"))),
                            React.createElement("div", { hidden: wargameTemplate.publishStatus !==
                                    WargameTemplatePublishStatus.published || !isVersionLatest },
                                React.createElement(Button, { key: "execute", appearance: "primary", iconAfter: React.createElement(VidPlayIcon, { label: "execute", size: "small" }), onClick: function (event) {
                                        setIsExecutionModelOpen(true);
                                    } }, "Execute")),
                            React.createElement("div", { hidden: wargameTemplate.publishStatus ===
                                    WargameTemplatePublishStatus.published },
                                React.createElement(Button, { key: "Publish", appearance: "primary", onClick: publishWargameTemplate, isDisabled: isTemplatePublishing },
                                    "Publish",
                                    " ",
                                    React.createElement("div", { hidden: !isTemplatePublishing },
                                        React.createElement(Spinner, null)))))))),
            React.createElement(Card, null,
                React.createElement(Table, { title: "Basic Information", cells: [
                        ["name", wargameTemplate.name ? wargameTemplate.name : ""],
                        [
                            "version",
                            wargameTemplate.version ? wargameTemplate.version : ""
                        ],
                        [
                            "environment",
                            wargameTemplate.environment
                                ? (wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.category) === "cronos" ||
                                    (wargameTemplate === null || wargameTemplate === void 0 ? void 0 : wargameTemplate.category) === "dynamic"
                                    ? "dynamic"
                                    : wargameTemplate.environment
                                : ""
                        ],
                        [
                            "status",
                            wargameTemplate.publishStatus
                                ? wargameTemplate.publishStatus
                                : "Not Available"
                        ],
                        [
                            "Created At",
                            wargameTemplate.createdAt
                                ? parseDateTime(wargameTemplate.createdAt)
                                : ""
                        ],
                        [
                            "Last Updated At",
                            wargameTemplate.updatedAt
                                ? parseDateTime(wargameTemplate.updatedAt)
                                : ""
                        ]
                    ] })),
            React.createElement(Card, null,
                React.createElement(WargameTemplateScheduleList, { templateID: templateId })),
            React.createElement(ExpandablePanel, { isCollapsed: isCollapsed, title: "Version History", onToggle: function () { return setIsCollapsed(function (prevState) { return !prevState; }); } },
                React.createElement(Container, null,
                    React.createElement(DynamicTable, { isFixedSize: true, head: {
                            cells: [
                                {
                                    key: "veriosn",
                                    content: "Version"
                                },
                                {
                                    key: "id",
                                    content: "ID"
                                },
                                {
                                    key: "createdAt",
                                    content: "Created At"
                                }
                            ]
                        }, rows: templateAllVersionsSortedDesc === null || templateAllVersionsSortedDesc === void 0 ? void 0 : templateAllVersionsSortedDesc.map(function (template) { return ({
                            cells: [
                                {
                                    key: template.version,
                                    content: (React.createElement("div", null,
                                        React.createElement("a", { href: "/services/" + encodeURIComponent(props.id) + "/resilience/ondemand/template-details?id=" + template.id },
                                            "v",
                                            template.version,
                                            "\u00A0"),
                                        templateId === template.id.toString() && (React.createElement(Lozenge, { appearance: "inprogress" }, "viewing"))))
                                },
                                {
                                    key: template.id,
                                    content: template.id.toString()
                                },
                                {
                                    key: template.createdAt,
                                    content: parseDateTime(template.createdAt)
                                }
                            ]
                        }); }) }))),
            wargameTemplate.premise ? (wargameTemplate.premise.map(function (premise) {
                updatePremiseRequestMethod(premise);
                return (React.createElement(Card, null,
                    React.createElement(PremiseDetailView, { premise: premise })));
            })) : (React.createElement("div", null,
                React.createElement(Separator, null),
                React.createElement("h4", null, "Premise Setup"),
                React.createElement(Separator, null),
                React.createElement(Card, null, "Premise is not configured"))),
            React.createElement(Grid, null,
                React.createElement(Separator, null),
                React.createElement("h3", null, "Task Group List"),
                React.createElement(GridColumn, { medium: 12 }, wargameTemplate.taskGroup !== undefined ? (wargameTemplate.taskGroup.length > 0 ? (wargameTemplate.taskGroup.map(function (taskGroup, index) { return (React.createElement(TaskGroupView, { taskGroup: taskGroup, index: index, isCollapsedInitially: true, key: "TaskGroup:" + index })); })) : (React.createElement(Card, null, "No Task Groups configured"))) : (React.createElement(Card, null, "No Task Groups configured"))))),
        React.createElement(TemplateScheduleFormView, { setIsMutationStarted: setIsMutationStarted, setIsExecutionModelOpen: setIsExecutionModelOpen, wargameTemplate: wargameTemplate, isExecutionModalOpen: isExecutionModalOpen, serviceId: props.id })));
};
export var TemplateDetailsPage = compose(graphql(serviceQuery, {}), graphql(TemplateDetailsQuery, {
    name: "templateDetailsData",
    options: function (_a) {
        var templateId = _a.templateId;
        return ({
            query: TemplateDetailsQuery,
            variables: { id: templateId, skip: true }
        });
    }
}), graphql(StartWargameMutation, {
    name: "startWargameMutation",
    options: function (props) { return ({
        query: StartWargameMutation,
        variables: { wargameInput: { warGameTemplateId: parseInt(props.id) } }
    }); }
}), graphql(PublishWargameTemplateMutation, {
    name: "publishWargameMutation",
    options: function (props) { return ({
        query: PublishWargameTemplateMutation,
        variables: { id: props.id }
    }); }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("Credo.CredoPage"), lifecycle({
    componentDidMount: function () {
        var search = window.location.search;
        var templateId = new URLSearchParams(search).get("id");
        if (!this.props.templateDetailsData.loading) {
            this.props.templateDetailsData.refetch({ id: templateId, skip: false });
        }
    }
}))(TemplateDetailsComponent);
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0.5rem;\n"], ["\n  margin: 0 0.5rem;\n"])));
var templateObject_1;
